import React, {Fragment} from 'react';
import createEditor, {referenceActionData} from '../form/ComponentEditor';
import Box from '../layout/Box';
import {SelectButton} from 'primereact/selectbutton';
import Modal from "../layout/Modal";
import classNames from "classnames";
import MoneyRepositoryForm from "./forms/MoneyRepositoryForm";
import MoneyRepositoryList from "./lists/MoneyRepositoryList";
import BoxEditor from "./BoxEditor";
import Button from "../form/Button";

class MoneyRepositoryEditor extends React.Component {

    state = {
        type: ['CashRepository', 'BankAccount', 'CreditCardTerminal'],
    };

    newRepository = async () => {
        await this.props.pristineForm();
        this.modal.show();
    }

    saveForm = async (event) => {
        await this.props.saveForm(event);
        this.list && this.list.refresh();
    }

    render() {

        const List = this.props.list || Box;
        const Editor = this.props.editor || BoxEditor;

        let {listFilter} = this.props;
        let filter = [];
        if (Array.isArray(listFilter)) {
            filter = [...listFilter];
        } else if (listFilter instanceof Object) {
            filter = [listFilter];
        }
        const types = [
            {label: 'Pénztár', value: 'CashRepository'},
            {label: 'Bankszámla', value: 'BankAccount'},
            {label: 'Terminál', value: 'CreditCardTerminal'}
        ];
        filter.push({
            field: "component_type", value: this.state.type, operator: 'in'
        });
        const newbutton = <Button
            type="button"
            disabled={this.props.isLoading}
            color="default"
            className="pull-left"
            onClick={this.newRepository}
        >
            Új
        </Button>;
        const actions = <Fragment>
            <Button
                disabled={!this.props.dirty || this.props.isLoading}
                color="primary"
                className="pull-right"
                onClick={this.saveForm}
            >
                Mentés
            </Button>
            <Button disabled={!this.props.values[this.props.componentConfig.idfield] || this.props.isLoading}
                    color="danger"
                    onClick={this.props.deleteForm}>
                Törlés
            </Button>
        </Fragment>;
        return (
            <Fragment>
                <Modal
                    ref={(el) => this.modal = el}
                    type="default"
                    size="medium"
                    header="Új pénztár felvétele"
                    buttons={[
                        ...(types.map((type) => {
                            return {
                                text: type.label,
                                onClick: async () => {
                                    const values = {...this.props.values, component_type: type.value, [this.props.componentConfig.idfield]: null};
                                    await this.props.setInitialValues(values);
                                    await this.props.setFormValues(values);
                                    this.modal.hide();
                                }
                            }
                        })),
                        {
                            text: 'Mégse',
                            onClose: true,
                            onClick: () => {
                                this.modal.hide();
                            }
                        }
                    ]}
                >
                    Milyen típusú pénztárt szeretnél felvenni?
                </Modal>
                <List
                    {...this.props}
                    theme="default"
                    header={"Pénztár lista"}
                    actions={<SelectButton value={this.state.type} multiple={true} options={types}
                                                 onChange={(e) => this.setState({type: e.value})}/>}
                    footer={newbutton}
                >
                    <MoneyRepositoryList ref={(el) => this.list = el} {...this.props} filter={filter}/>
                </List>
                {this.props.values.component_type &&
                    <Fragment>
                        <Editor
                            {...this.props}
                            theme="default"
                            header={"Pénztár adatai"}
                            collapsed={this.props.collapsed || false}
                            footer={actions}
                        >
                            <MoneyRepositoryForm {...this.props} />
                        </Editor>
                    </Fragment>
                }
            </Fragment>
        );
    }
}

export default createEditor({
    componentName: "MoneyRepository",
    WrappedComponent: MoneyRepositoryEditor,
    props: {
        componentActions: async (action, data, params, componentConfig) => {
            data = await referenceActionData(data, componentConfig);
            return {action,data,params};
        }
    }
});
